import { HttpClient } from "@angular/common/http";
import { catchError, map } from "rxjs/operators";
import { API_ADDRESS, httpOptionsDefault } from "../constants";

export class ChargerController {

    _controllerName = "charger"

 
    constructor(public _http: HttpClient) {

      
    } 
    

    makeCharge(value: number, customerId: number, year: number, month: number) {
       
        let address = API_ADDRESS + `/${this._controllerName }/makeCharge`;

        let charge =   
        {
            value : value,
            customerId : customerId,
            year : year,
            month : month
        };

        return this._http.post(address,charge,  httpOptionsDefault)
            .pipe(
                map(result => {

                    return result;
                }

                ),
                catchError(error => {

                    return error;
                })
            )
            .toPromise().then((result: any) => {

                return result;
            });
      }
      
 
      

    getChargerList(year:number,month:number) : Promise<any[]> {

        let address = API_ADDRESS + `/${this._controllerName }/getList/${year}/${month}`;

    
        return this._http.get(address,  httpOptionsDefault)
            .pipe(
                map(result => {

                    return result;
                }

                ),
                catchError(error => {

                    return error;
                })
            )
            .toPromise().then((result: any) => {

               


                return result;
            });

    }  

}